export default __webpack_public_path__ + "static/media/C7.0cb46584.mp3";